import { create } from 'zustand';
export const useSidebarStore = create((set) => ({
    isOpen: typeof window !== 'undefined' ? window.innerWidth >= 1024 : true,
    toggle: () => set((s) => ({ isOpen: !s.isOpen })),
    close: () => set({ isOpen: false }),
}));
